import React, { useContext } from "react";
import { AppContext } from "../../../App";
import CustomModal from "../../CustomModal";
import usePracticesByClientSelected from "../../pages/Connections/components/PracticesByClientSelected/hooks/usePracticesByClientSelected";
import PracticesByClientSelectedDiva from "../../pages/ConnectionsDiva/components/practices-by-client-selected-diva/PracticesByClientSelectedDiva";
import { Button } from "../../ui/button";
import { RefreshCw } from "lucide-react";
import { useLocation } from "react-router-dom";
import { REFRESH_ALL_TRANSACTIONS_DIVA_EVENT } from "../../pages/AllTransactionsDiva/hooks/useAllTransactionsDiva";

export default function TemplateFooter() {
  const appContext = useContext(AppContext);
  const showPracticeModal = appContext.get("showPracticeModal");
  const location = useLocation();

  const { client, countSelectedPractices } = usePracticesByClientSelected();

  return (
    <footer className="site-footer !p-0 h-[50px]">
      <div className="site-footer-legal mt-[1rem] ml-[1rem]">
        {/* <CurrentYear /> Diva*/}
        {client ? (
          <>
            <strong>
              {client.clientName} - practices selected: {countSelectedPractices}
            </strong>
          </>
        ) : (
          "*No Practice Selected*"
        )}
      </div>
      {location.pathname === "/allTransaction" && (
        <div className="site-footer-right mt-[0.5rem] mr-[1rem]">
          <Button
            variant="outline"
            className="bg-white text-gray-700 hover:bg-gray-100"
            size="sm"
            onClick={() => {
              window.dispatchEvent(
                new Event(REFRESH_ALL_TRANSACTIONS_DIVA_EVENT),
              );
            }}
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Refresh Data
          </Button>
        </div>
      )}
      {showPracticeModal && (
        <CustomModal
          size="lg"
          title="Select Practices"
          show={showPracticeModal}
          onHide={() => appContext.set("showPracticeModal", false)}
        >
          <PracticesByClientSelectedDiva
            closeModal={() => appContext.set("showPracticeModal", false)}
          />
        </CustomModal>
      )}
    </footer>
  );
}
